import React, { FC } from 'react';
import { Tabs } from '@components/UIKit/Tabs/Tabs';
import { ITabItem } from '@specs/types';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
import { SocialManagerView } from '@specs/views';
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
}
export const TabItems: FC<Props> = ({
  shortid
}) => {
  const router = useRouter();
  const tabs: ITabItem[] = [{
    text: 'feed.page.feed.tab.posts',
    icon: {
      name: 'posts'
    },
    href: {
      pathname: LinksEnum.USER,
      query: {
        slug: shortid
      }
    },
    isActive: router.pathname === LinksEnum.USER
  }, {
    text: 'feed.page.feed.tab.toys',
    icon: {
      name: 'toys'
    },
    href: {
      pathname: LinksEnum.USER_TOYS,
      query: {
        slug: shortid
      }
    },
    isActive: router.pathname === LinksEnum.USER_TOYS
  }];
  return <Tabs tabs={tabs} data-sentry-element="Tabs" data-sentry-component="TabItems" data-sentry-source-file="TabItems.tsx" />;
};